import type { ContractOption } from './types';
import { ContractOptionId } from './types';

export const CONTRACT_OPTIONS: ContractOption[] = [
  {
    id: ContractOptionId.CONTRACT,
    title: 'New Contract',
    description: 'A new contract ready to populate',
  },
  {
    id: ContractOptionId.ENDORSEMENT,
    title: 'Endorsement',
    description: 'A new endorsement for an existing contract',
  },
  {
    id: ContractOptionId.RENEWAL,
    title: 'Renewal Contract',
    description: 'Select an existing contract to renew',
  },
];
